/** User Service API route prefixes (relative to userClient base URL). */
export const UserApiRoutePrefix = {
  ClinicianProfiles: '/api/v1/clinician-profiles',
} as const;

/** Path segments under clinician-profiles resource routes. */
export const UserApiClinicianProfileSegment = {
  ProviderMapApprovals: 'provider-map-approvals',
} as const;

/** Registration flow — account setup (step 3). */
export const REGISTRATION_ACCOUNT_SETUP_ROUTE = '/registration/account-setup';

/** Signed-in portal dashboard. */
export const PORTAL_DASHBOARD_ROUTE = '/dashboard';

/** Signed-in exams list (dashboard View All). */
export const PORTAL_EXAMS_ROUTE = '/exams';
